import { render } from "./EvaluationHistory.vue?vue&type=template&id=4e24326a"
import script from "./EvaluationHistory.vue?vue&type=script&lang=js"
export * from "./EvaluationHistory.vue?vue&type=script&lang=js"

import "./EvaluationHistory.vue?vue&type=style&index=0&id=4e24326a&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__